import { render, staticRenderFns } from "./imageTxtDetails.vue?vue&type=template&id=1da77718"
import script from "./imageTxtDetails.vue?vue&type=script&lang=js"
export * from "./imageTxtDetails.vue?vue&type=script&lang=js"
import style0 from "./imageTxtDetails.vue?vue&type=style&index=0&id=1da77718&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports